module.exports = __webpack_public_path__ + "img/drh5_language_jp.c4629e4b.png";